import { render, staticRenderFns } from "./SpcmStudentUniversityReco.vue?vue&type=template&id=54a97044"
import script from "./SpcmStudentUniversityReco.vue?vue&type=script&lang=js"
export * from "./SpcmStudentUniversityReco.vue?vue&type=script&lang=js"
import style0 from "./SpcmStudentUniversityReco.vue?vue&type=style&index=0&id=54a97044&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports